import useDataAttribute from '../infrastructure/DataAttributeContext';
import * as style from './GridItemTags.module.css';

export interface Tag {
    _key: string;
    _id: string;
    name: string;
    slug: {
        current: string;
    };
    mainTagCategory?: {
        _id: string;
        name: string;
        slug: {
            current: string;
        };
    };
}

export interface Props {
    tags?: Tag[];
}

export default function GridItemTags({ tags }: Props) {
    const dataAttr = useDataAttribute();
    return (
        <ul className={style.tags} data-sanity={dataAttr?.('tags')} itemProp="keywords">
            {tags?.filter(Boolean).map(({ name, _key }) => (
                <li key={_key} data-sanity={dataAttr?.(['tags', { _key }])}>
                    {name}
                </li>
            ))}
        </ul>
    );
}
